import React from 'react';

import ChildrenPropType from 'lib/CustomPropTypes/children';

function VideoList(props) {
  const { children } = props;

  return (
    <div className="ontheshow__video-list">
      { children }
    </div>
  );
}

VideoList.propTypes = {
  children: ChildrenPropType,
};

VideoList.defaultProps = {
  children: undefined,
};

export default VideoList;
